(function ($) {
  Drupal.behaviors.mppFilterSetV2 = {
    attached: false,
    nodes: {},
    filterString: 'all',
    filters: [],
    skuFilters: [],
    selectors: {
      html: 'html',
      body: 'body',
      siteHeader: '.site-header__container',
      mppContainer: '.js-mpp-container-v3, .js-mpp-custom-container-v2',
      mppContainerControls: '.js-mpp-container__controls',
      mppGridFiltered: 'js-mpp-grid--filtered',
      productGrid: '.js-product-grid-filterable',
      productGridItem: '.js-product-grid-item-product',
      productBriefShadesGrid: '.js-product-brief-shades__grid',
      productBriefShadesItem: '.js-product-brief-shades-item',
      filterTitleBtn: '.js-mpp-filter-title',
      filterActiveCount: '.js-mpp-filter--active-filters-count',
      filterActiveOptionsContainer: '.js-mpp-filter-active-options__container',
      filterActiveOptionsList: '.js-mpp-filter-active-options',
      filterActiveOptionsSeparatorPrev: '.js-mpp-filter-active-options__separator-prev',
      filterActiveOptionsSeparatorNext: '.js-mpp-filter-active-options__separator-next',
      filterActiveOptionElement: '.js-mpp-filter-active-option',
      filterActiveOptionName: '.js-mpp-filter-active-option__name',
      filterActiveOptionRemove: '.js-mpp-filter-active-option__remove',
      filterSetContainer: '.js-mpp-filter-set__container',
      filterSetContainerOverlay: '.js-mpp-filter-set__container--overlay',
      filterSetContainerInner: '.js-mpp-filter-set__container--inner',
      filterSet: '.js-mpp-filter-set-v2',
      filterSetButton: '.js-mpp-filter-set-button',
      filterSetSubmit: '.js-mpp-filter-set-submit',
      filterSetReset: '.js-mpp-filter-set-reset',
      filterSetSection: '.js-mpp-filter-set-section',
      filterSetFilters: '.js-mpp-filter-set__filters',
      filterSetTitle: '.js-mpp-filter-set__title',
      filterSetSelections: '.js-mpp-filter-set-selections',
      filterTriggerBtn: '.js-mpp-filter-cta',
      filterCloseBtn: '.js-mpp-filter-cta--close',
      productCountNumber: '.js-breadcrumb__level--count-number, .js-mpp-product-count-number',
      productCountProductSuffix: '.js-mpp-product-count-product-suffix',
      productCountProductsSuffix: '.js-mpp-product-count-products-suffix',
      gnavHeader: '.js-site-header-formatter__header',
      stickyNodeContent: '.js-sticky-node-content'
    },
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      var $mpp = $(self.selectors.mppContainer, context);
      self.setup($mpp);
    },
    setup: function ($mpp) {
      var self = this;

      self.getDom($mpp);
      self.init($mpp);
      self.setEvents($mpp);
    },
    getDom: function ($mpp) {
      var self = this;

      $mpp.nodes = {};
      $mpp.nodes.$mppContainerControls = $(self.selectors.mppContainerControls, $mpp);
      $mpp.nodes.$productGrid = $(self.selectors.productGrid, $mpp);
      $mpp.nodes.$productGridItem = $(self.selectors.productGridItem, $mpp);
      $mpp.nodes.$productBriefShadesGrid = $(self.selectors.productBriefShadesGrid, $mpp);
      $mpp.nodes.$filterTitleBtn = $(self.selectors.filterTitleBtn, $mpp);
      $mpp.nodes.$filterActiveCount = $(self.selectors.filterActiveCount, $mpp);
      $mpp.nodes.$filterActiveOptionsContainer = $(
        self.selectors.filterActiveOptionsContainer,
        $mpp
      );
      $mpp.nodes.$filterActiveOptionsList = $(self.selectors.filterActiveOptionsList, $mpp);
      $mpp.nodes.$filterActiveOptionsSeparatorPrev = $(
        self.selectors.filterActiveOptionsSeparatorPrev,
        $mpp
      );
      $mpp.nodes.$filterActiveOptionsSeparatorNext = $(
        self.selectors.filterActiveOptionsSeparatorNext,
        $mpp
      );
      $mpp.nodes.$filterActiveOptionElement = $(self.selectors.filterActiveOptionElement, $mpp);
      $mpp.nodes.$filterSetContainer = $(self.selectors.filterSetContainer, $mpp);
      $mpp.nodes.$filterSetContainerOverlay = $(self.selectors.filterSetContainerOverlay, $mpp);
      $mpp.nodes.$filterSetContainerInner = $(self.selectors.filterSetContainerInner, $mpp);
      $mpp.nodes.$filterSetSelections = $(self.selectors.filterSetSelections, $mpp);
      $mpp.nodes.$filterSet = $(self.selectors.filterSet, $mpp);
      $mpp.nodes.$filterSetButton = $(self.selectors.filterSetButton, $mpp);
      $mpp.nodes.$filterSetSubmit = $(self.selectors.filterSetSubmit, $mpp);
      $mpp.nodes.$filterSetReset = $(self.selectors.filterSetReset, $mpp);
      $mpp.nodes.$filterSetSection = $(self.selectors.filterSetSection, $mpp);
      $mpp.nodes.$filterSetFilters = $(self.selectors.filterSetFilters, $mpp);
      $mpp.nodes.$filterSetTitle = $(self.selectors.filterSetTitle, $mpp);
      $mpp.nodes.$filterTriggerBtn = $(self.selectors.filterTriggerBtn, $mpp);
      $mpp.nodes.$filterCloseBtn = $(self.selectors.filterCloseBtn, $mpp);
      $mpp.nodes.$productCountNumber = $(
        self.selectors.productCountNumber,
        $mpp.nodes.$filterSetContainerInner
      );
      $mpp.nodes.$productCountProductSuffix = $(
        self.selectors.productCountProductSuffix,
        $mpp.nodes.$filterSetContainerInner
      );
      $mpp.nodes.$productCountProductsSuffix = $(
        self.selectors.productCountProductsSuffix,
        $mpp.nodes.$filterSetContainerInner
      );
    },
    init: function ($mpp) {
      var self = this;

      var hasFilters = false;
      var urlString = window.location.href;

      // Loop through all products
      $mpp.nodes.$productGridItem.each(function () {
        var $thisProduct = $(this);
        var hasSkuFilters = false;

        // If not filterable, continue
        if (!$thisProduct.data('attributes').tags && !$(this).data('attributes').skuTags) {
          return;
        }

        var data = '';

        if ($thisProduct.data('attributes').tags) {
          data = $thisProduct.data('attributes').tags;
          // process product filters first
          properTags = self.processTags(data);
          // loop tags and add filter class to element
          hasFilters = self.loopTags(
            $mpp,
            $thisProduct,
            properTags,
            'product-filter',
            $mpp.nodes.$filterSetFilters
          );
        }

        if ($thisProduct.data('attributes').skuTags) {
          data = $thisProduct.data('attributes').skuTags;
          // process sku filters first
          properTags = self.processTags(data);
          // loop tags and add filter class to element + filter type
          hasSkuFilters = self.loopTags(
            $mpp,
            $thisProduct,
            properTags,
            'sku-filter',
            $mpp.nodes.$filterSetFilters
          );
          if (!hasFilters && hasSkuFilters) {
            hasFilters = true;
          }
          self.processShadesForFiltering(
            $mpp,
            $thisProduct.find(self.selectors.productBriefShadesItem)
          );
        }
      });

      if (hasFilters) {
        // show the filter buttons if there are is least 1 filter available
        $mpp.nodes.$filterSet.removeClass('hidden');
      }

      // Loop through our filter sets and hide any without filters with tags
      $mpp.nodes.$filterSetFilters.each(function () {
        if ($(this).children('.hidden').length === $(this).children().length) {
          // used removed instead of hide so unused sections wont interfere with the child counting
          $(this).closest('.mpp-filter-set__section').remove();
        }
      });

      $mpp.nodes.$filterSetButton.attr('aria-checked', 'false');

      if (urlString.includes('?filter=')) {
        var $currentFilter = '';
        var filterValues = urlString.split('?filter=').pop().split(',');

        filterValues.forEach(function (val) {
          $currentFilter = $mpp.nodes.$filterSetButton.filter(
            '[data-filter=".product-grid__item--filter-' + val + '"]'
          );
          if ($currentFilter.length > 0) {
            $currentFilter.addClass('active').attr('aria-checked', 'true');
            self.updateResultCount($mpp);
            self.updateAvailableFilters($mpp);
            self.toggleFilterButtons($mpp);
          }
        });
        $mpp.nodes.$productGrid.addClass('mixitup-initialized');
        $mpp.nodes.$mppContainerControls.removeClass('hidden');
        self.filter($mpp);
      }
    },
    setEvents: function ($mpp) {
      var self = this;
      var filterPillsScrollActive = false;
      var filterPillsScrollStartX = 0;
      var filterPillsScrollLeft = 0;

      // Collect each filter
      $mpp.nodes.$filterSetSection.each(function () {
        var $triggers = $(self.selectors.filterSetButton, this);

        $triggers
          .once()
          .on('click', function (event) {
            if ($(this).hasClass('disabled')) {
              return;
            }
            event.preventDefault();
            var selected = $(this).attr('aria-checked') !== 'false';
            $(this).toggleClass('active').attr('aria-checked', !selected);
            self.updateResultCount($mpp);
            self.updateAvailableFilters($mpp);
            self.updateActiveFilterCount($mpp);
            self.toggleFilterButtons($mpp);
            self.changeFilterParam($mpp);
          })
          .on('keydown', function (event) {
            if (event.key === 'Enter') {
              if ($(this).hasClass('disabled')) {
                return;
              }
              var selected = $(this).attr('aria-checked') !== 'false';
              $(this).toggleClass('active').attr('aria-checked', !selected);
              self.updateResultCount($mpp);
              self.updateAvailableFilters($mpp);
              self.updateActiveFilterCount($mpp);
              self.toggleFilterButtons($mpp);
              self.changeFilterParam($mpp);
            }
          });
      });

      // Apply results
      $mpp.nodes.$filterSetSubmit
        .once()
        .on('click', function (event) {
          var $button = $(this);

          event.preventDefault();
          if ($button.hasClass('button--disabled')) {
            return;
          }
          if ($button.hasClass('js-reset-filters')) {
            self.reset($mpp);
          } else {
            self.filter($mpp);
          }
          self.close($mpp);
          $mpp.nodes.$filterTriggerBtn.focus();
        })
        .on('keydown', function (event) {
          if (event.key === 'Tab' && !event.shiftKey) {
            event.preventDefault();
            $mpp.nodes.$filterCloseBtn.focus();
          }
        });

      // Toggle menu
      $mpp.nodes.$filterTriggerBtn
        .once()
        .on('click', function () {
          if ($(this).hasClass('mpp-filter-cta--close')) {
            self.close($mpp);
          } else {
            self.toggleFiltersContainer($mpp);
            self.updateActiveFilterCount($mpp);
          }
        })
        .on('keydown', function (event) {
          if (event.key === 'Enter') {
            if ($(this).hasClass('mpp-filter-cta--close')) {
              self.close($mpp);
            } else {
              self.toggleFiltersContainer($mpp);
              self.updateActiveFilterCount($mpp);
            }
            $mpp.nodes.$filterCloseBtn.focus();
          }
        });

      $mpp.nodes.$filterTitleBtn.once().on('click', function () {
        self.close($mpp);
        self.changeFilterParam($mpp);
      });

      $mpp.nodes.$filterCloseBtn
        .once()
        .on('click', function () {
          self.close($mpp);
          self.changeFilterParam($mpp);
        })
        .on('keydown', function (event) {
          switch (event.key) {
            case 'Enter':
              self.close($mpp);
              self.changeFilterParam($mpp);
              $mpp.nodes.$filterTriggerBtn.focus();
              break;
            case 'Tab':
              if (event.shiftKey) {
                event.preventDefault();
                $mpp.nodes.$filterSetSubmit.focus();
              }
              break;
          }
        });

      $mpp.nodes.$filterSetTitle.once().on('click', function () {
        var $this = $(this);

        if ($this.hasClass('disabled')) {
          return;
        }
        $this.toggleClass('opened').next(self.selectors.filterSetFilters).toggleClass('collapsed');
      });

      $(document).on('keyup', function (event) {
        if (event.key === 'Escape' && $mpp.nodes.$filterSetContainer.is(':visible')) {
          self.close($mpp);
          $mpp.nodes.$filterTriggerBtn.focus();
        }
      });

      $(self.selectors.html)
        .once('filter-overlay')
        .on('mousedown', function (event) {
          if (
            $mpp.nodes.$filterSetContainer.is(':visible') &&
            ($(event.target).parent().hasClass('mpp-container__overlay') ||
              $(event.target).closest(self.selectors.siteHeader).length)
          ) {
            self.close($mpp);
          }
        });

      $mpp.nodes.$filterSetReset.once().on('click', function (event) {
        event.preventDefault();
        if ($(this).hasClass('button--disabled')) {
          return;
        }
        self.clearFilters($mpp);
        self.changeFilterParam($mpp);
        if ($mpp.nodes.$productGrid.hasClass(self.selectors.mppGridFiltered)) {
          $mpp.nodes.$filterSetSubmit.addClass('js-reset-filters');
        } else {
          self.toggleFilterButtons($mpp);
        }
        if ($(this).closest(self.selectors.filterActiveOptionsContainer).length > 0) {
          self.reset($mpp);
          $mpp.nodes.$filterTriggerBtn.focus();
        }
      });

      $mpp.nodes.$productGrid.once().on('mixEnd', function () {
        self.toggleFilterButtons($mpp);
        // trigger event to filter skus
        $(document).trigger('grid.activeFilter', { skuFilters: self.skuFilters });
      });

      $mpp.nodes.$filterActiveOptionsList
        .once()
        .on('mousedown', function (event) {
          filterPillsScrollActive = true;
          filterPillsScrollStartX = event.pageX - $mpp.nodes.$filterActiveOptionsList[0].offsetLeft;
          filterPillsScrollLeft = $mpp.nodes.$filterActiveOptionsList[0].scrollLeft;
        })
        .on('mouseleave mouseup', function () {
          filterPillsScrollActive = false;
        })
        .on('mousemove', function (event) {
          if (!filterPillsScrollActive) return;
          event.preventDefault();
          var offsetLeft = event.pageX - $mpp.nodes.$filterActiveOptionsList[0].offsetLeft;
          $mpp.nodes.$filterActiveOptionsList[0].scrollLeft =
            filterPillsScrollLeft - offsetLeft + filterPillsScrollStartX;
          self.toggleFilterPillsSeparators($mpp);
        })
        .on('touchmove scroll', function () {
          self.toggleFilterPillsSeparators($mpp);
        });
    },

    processTags: function (tagsData) {
      if (typeof tagsData !== 'string') {
        return [];
      }
      var newData = tagsData
        .replace(/-/g, '')
        .replace(/ /g, '')
        .replace(/\s+/g, '')
        .replace(/\//g, '')
        .toLowerCase();
      // Loop through our tags, split them by comma, then trim the whitespace
      var tags = _.map(newData.split(','), $.trim);

      return tags;
    },

    loopTags: function ($mpp, $elem, properTags, filterType) {
      hasFilters = false;
      var filterClass = '';

      // Loop through our tags, and add the class to this product item
      _.each(properTags, function (index) {
        filterClass = 'product-grid__item--filter-' + index;
        $elem.addClass(filterClass);
        hasFilters = true;
        if ($mpp.nodes.$filterSetFilters.length) {
          // show the filter when called from product
          $mpp.nodes.$filterSetFilters
            .find('[data-filter=".' + filterClass + '"]')
            .data('filterType', filterType)
            .attr('data-filter-type', filterType)
            .removeClass('hidden');
        }
      });

      return hasFilters;
    },

    processShadesForFiltering: function ($mpp, $shades) {
      var self = this;

      $.each($shades, function () {
        var $thisShade = $(this);

        if ($thisShade.data('attributes').tags) {
          var tags = self.processTags($thisShade.data('attributes').tags);

          self.loopTags($mpp, $thisShade, tags, 'sku-filter', {});
        }
      });
    },

    // Deeplinking support
    getUrlParameter: function (name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);

      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    toggleFilterButtons: function ($mpp) {
      var self = this;

      var filterActive = $mpp.nodes.$filterSetButton.filter('.active').length || false;
      var gridReset = $mpp.nodes.$filterSetButton.filter('.selected').length || false;

      if (filterActive) {
        $mpp.nodes.$filterSetSubmit
          .removeClass('button--disabled')
          .removeClass('disabled')
          .removeClass('js-reset-filters');
        $mpp.nodes.$filterSetReset.removeClass('disabled');
        $mpp.nodes.$productGrid.addClass(self.selectors.mppGridFiltered);
      }
      if (gridReset && !filterActive) {
        // if there are no active filters but the grid was filtered
        // by something ( so there are selected item ), the submit button has to be
        // flaged as reset
        $mpp.nodes.$filterSetSubmit.addClass('js-reset-filters');
      }
    },

    changeFilterParam: function ($mpp) {
      var self = this;

      var filterParameter = [];
      var filterContent = '';
      var filterParameterSet = '';

      var urlString = window.location.href.split('?')[0];
      $mpp.nodes.$filterSetButton.filter('.active').each(function () {
        filterContent = $(this).attr('data-filter').split('.product-grid__item--filter-').join('');
        filterParameter.push(filterContent);
      });
      if (filterParameter.length > 0) {
        filterParameterSet = '?filter=' + filterParameter.join(',');
      }
      window.history.pushState({}, '', urlString + filterParameterSet);
    },

    getFilterCount: function ($mpp) {
      var activeFilters = [];

      $mpp.nodes.$filterSetButton.filter('.active').each(function () {
        activeFilters.push($(this).data('filter'));
      });
      var activeFilterSelector = activeFilters.join('') || $mpp.nodes.$productGridItem;

      return parseInt($mpp.nodes.$productGridItem.filter(activeFilterSelector).length);
    },

    simulateFilterCount: function ($mpp, simulateSelector) {
      var self = this;

      activeFilters = [];

      $mpp.nodes.$filterSetButton.filter('.active').each(function () {
        activeFilters.push($(this).data('filter'));
      });
      activeFilters.push(simulateSelector);
      var activeFilterSelector = activeFilters.join('') || self.selectors.productGridItem;

      return parseInt($mpp.nodes.$productGridItem.filter(activeFilterSelector).length);
    },

    updateResultCount: function ($mpp) {
      var self = this;

      // Display # of filtered results
      var count = self.getFilterCount($mpp);

      $mpp.nodes.$productCountNumber.text(count);

      if (count > 1) {
        $mpp.nodes.$productCountProductSuffix.addClass('hidden');
        $mpp.nodes.$productCountProductsSuffix.removeClass('hidden');
      } else {
        $mpp.nodes.$productCountProductSuffix.removeClass('hidden');
        $mpp.nodes.$productCountProductsSuffix.addClass('hidden');
      }
    },

    updateAvailableFilters: function ($mpp) {
      var self = this;

      $mpp.nodes.$filterSetButton.filter(':not(.active)').each(function () {
        var simulateCount = self.simulateFilterCount($mpp, $(this).data('filter'));

        self.toggleFilterElement(simulateCount, $(this));
      });
      var availableFilters = 0;
      var $filterTitle = $();

      $mpp.nodes.$filterSetFilters.each(function () {
        availableFilters = $(this)
          .find($mpp.nodes.$filterSetButton)
          .filter(':not(.disabled)').length;
        $filterTitle = $(this).prev(self.selectors.filterSetTitle);
        if ($filterTitle.length) {
          self.toggleFilterElement(availableFilters, $filterTitle);
        }
      });
    },

    updateActiveFilterCount: function ($mpp) {
      var self = this;

      var activeFiltersCount = $mpp.nodes.$filterSetButton.filter('.active').length;
      if (!activeFiltersCount) {
        $(self.selectors.filterActiveCount, self.selectors.filterSetSubmit).html('');
      } else {
        // Update filters count
        $(self.selectors.filterActiveCount, self.selectors.filterSetSubmit).html(
          '(' + activeFiltersCount + ')'
        );
      }
    },

    toggleFilterElement: function (count, $el) {
      if (count === 0) {
        $el.addClass('disabled').attr('aria-disabled', 'true');
      } else {
        $el.removeClass('disabled').attr('aria-disabled', 'false');
      }
    },

    // Grabs the filter selectors and joins them
    filter: function ($mpp) {
      var self = this;

      var activeFiltersCount = 0;
      var $filterActiveOption = $();
      var filterActiveOptionLabel = '';
      self.filters = [];
      self.skuFilters = [];

      $(self.selectors.filterActiveOptionElement).remove();
      $mpp.nodes.$filterSetButton.filter('.active').each(function () {
        self.filters.push($(this).data('filter'));
        if ($(this).data('filterType') === 'sku-filter') {
          self.skuFilters.push($(this).data('filter'));
        }
        $filterActiveOption = $mpp.nodes.$filterActiveOptionElement.clone().removeClass('hidden');
        $filterActiveOption.attr('data-filter', $(this).data('filter'));
        $filterActiveOption.attr('data-filter-type', $(this).data('filter-type'));
        filterActiveOptionLabel = $(this).data('filter-type') + $(this).text();
        $filterActiveOption
          .find(self.selectors.filterActiveOptionRemove)
          .attr('aria-label', filterActiveOptionLabel);
        $filterActiveOption.find(self.selectors.filterActiveOptionName).text($(this).text());
        $filterActiveOption.appendTo($mpp.nodes.$filterActiveOptionsList);
      });

      $(self.selectors.filterActiveOptionRemove)
        .once()
        .on('click', function () {
          var filter = $(this).closest(self.selectors.filterActiveOptionElement).data('filter');
          $currentFilter = $mpp.nodes.$filterSetButton.filter('[data-filter="' + filter + '"]');
          if ($currentFilter.length > 0) {
            $currentFilter.removeClass('active').attr('aria-checked', 'false');
            self.updateResultCount($mpp);
            self.updateAvailableFilters($mpp);
            self.toggleFilterButtons($mpp);
            self.changeFilterParam($mpp);
          }
          self.filter($mpp);
        })
        .on('keydown', function (event) {
          if (event.key === 'Enter') {
            var filter = $(this).closest(self.selectors.filterActiveOptionElement).data('filter');
            $currentFilter = $mpp.nodes.$filterSetButton.filter('[data-filter="' + filter + '"]');
            if ($currentFilter.length > 0) {
              $currentFilter.removeClass('active').attr('aria-checked', 'false');
              self.updateResultCount($mpp);
              self.updateAvailableFilters($mpp);
              self.toggleFilterButtons($mpp);
              self.changeFilterParam($mpp);
            }
            self.filter($mpp);
            $mpp.nodes.$filterTriggerBtn.focus();
          }
        });

      $(document).trigger('menu:anchored_update');

      // Compound selector strings to use 'and' logic
      activeFiltersCount = self.filters.length;
      if (!activeFiltersCount) {
        $mpp.nodes.$filterActiveCount.html('');
        $mpp.nodes.$filterActiveOptionsContainer.addClass('hidden');
      } else {
        // Hide promo items when filters are active
        self.filters.push(self.selectors.productGridItem);

        // Update filters count
        $mpp.nodes.$filterActiveCount.html('(' + activeFiltersCount + ')');
        $mpp.nodes.$filterActiveOptionsContainer.removeClass('hidden');

        var $filterActiveOptionsList = $(self.selectors.filterActiveOptionsList, $mpp);
        if (
          $filterActiveOptionsList.length > 0 &&
          $filterActiveOptionsList[0].scrollWidth > $filterActiveOptionsList[0].clientWidth
        ) {
          $mpp.nodes.$filterActiveOptionsContainer.addClass('scrollable');
        } else {
          $mpp.nodes.$filterActiveOptionsContainer.removeClass('scrollable');
        }
      }
      self.filterString = self.filters.join('') || 'all';
      $mpp.nodes.$productGrid.data('preFilterString', self.filterString);
      if ($mpp.nodes.$productGrid.hasClass('mixitup-initialized')) {
        $mpp.nodes.$productGrid.fadeTo(300, 0.4, function () {
          $(this).mixItUp('filter', self.filterString);
        });
        $mpp.nodes.$filterSetButton.removeClass('selected').filter('.active').addClass('selected');
        $mpp.nodes.$filterSetContainer.addClass('mpp-filter-set--filtered');
        if (self.filterString === 'all') {
          $mpp.removeClass('mpp-container--filtered');
        } else {
          $mpp.addClass('mpp-container--filtered');
        }
        self.toggleFilterPillsSeparators($mpp);
        self.scrollToMPPTop($mpp);
      }
    },

    clearFilters: function ($mpp) {
      var self = this;

      self.filters = [];
      self.skuFilters = [];
      $mpp.nodes.$filterSetButton.removeClass('active').attr('aria-checked', 'false');
      self.updateAvailableFilters($mpp);
      self.updateResultCount($mpp);
      self.updateActiveFilterCount($mpp);
    },

    // Reset filters
    reset: function ($mpp) {
      var self = this;

      $mpp.nodes.$productGrid.removeClass(self.selectors.mppGridFiltered);
      $mpp.nodes.$productGrid.fadeTo(300, 0.4, function () {
        $(this).mixItUp('filter', 'all');
      });
      $mpp.nodes.$filterSetButton
        .removeClass('active')
        .removeClass('selected')
        .attr('aria-checked', 'false');
      self.toggleFilterButtons($mpp);
      $mpp.nodes.$filterSetContainer.removeClass('mpp-filter-set--filtered');
      $mpp.removeClass('mpp-container--filtered');
      $mpp.nodes.$filterSetSelections.fadeOut(100, function () {
        $(this).text('').removeClass('active');
      });
      $(document).trigger('grid.reset.filters');
      $mpp.nodes.$filterActiveCount.html('');
      $mpp.nodes.$filterActiveOptionsContainer.addClass('hidden');

      self.scrollToMPPTop($mpp);
    },

    // Close menu
    close: function ($mpp) {
      var self = this;

      self.toggleFiltersContainer($mpp);
      $mpp.nodes.$filterSetButton
        .filter('.selected')
        .addClass('active')
        .attr('aria-checked', 'true');
      self.updateResultCount($mpp);
    },

    toggleFiltersContainer: function ($mpp) {
      var self = this;

      $mpp.nodes.$filterSetContainer.css({ overflow: '' });
      $mpp.nodes.$mppContainerControls.toggleClass('full-page-takeover');

      $mpp.nodes.$mppContainerControls[0].scrollIntoView();
      $(self.selectors.html).toggleClass('mpp-container__overlay');
      $mpp.nodes.$filterSetContainer.toggle();
      $mpp.nodes.$filterSetContainerOverlay.animate(
        {
          opacity: 0
        },
        400,
        function () {
          $mpp.nodes.$filterSetContainerInner.removeClass('loading');
          $mpp.nodes.$filterSetContainerOverlay.removeClass('loading');
        }
      );
    },

    toggleFilterPillsSeparators: function ($mpp) {
      var $filterActiveOptionsList = $mpp.nodes.$filterActiveOptionsList[0];
      var filterActiveOptionsListWidth = Math.ceil(
        $filterActiveOptionsList.getBoundingClientRect().width
      );
      if ($filterActiveOptionsList.scrollLeft > 0) {
        $mpp.nodes.$filterActiveOptionsSeparatorPrev.removeClass('hidden');
      } else {
        $mpp.nodes.$filterActiveOptionsSeparatorPrev.addClass('hidden');
      }
      if (
        parseInt($filterActiveOptionsList.scrollWidth - $filterActiveOptionsList.scrollLeft) >
        filterActiveOptionsListWidth
      ) {
        $mpp.nodes.$filterActiveOptionsSeparatorNext.removeClass('hidden');
      } else {
        $mpp.nodes.$filterActiveOptionsSeparatorNext.addClass('hidden');
      }
    },

    scrollToMPPTop: function ($mpp) {
      var self = this;
      var stickyNavHeight = 0;
      var mppTop = $mpp.offset().top;
      var curTop = $(window).scrollTop();

      if (mppTop < curTop) {
        stickyNavHeight += $(self.selectors.gnavHeader).outerHeight(true);
      }

      if ($(self.selectors.stickyNodeContent).length > 0) {
        stickyNavHeight += $mpp.nodes.$mppContainerControls.outerHeight(true);
      }

      $(self.selectors.html).animate(
        {
          scrollTop: mppTop - stickyNavHeight
        },
        500,
        'linear'
      );
    }
  };
})(jQuery);
